import React from 'react';

import { sections } from 'components/lexemes';
import LocaleContext from 'lib/locale-context';
import { getLanguageAlternates, SHARE_IMAGE_URL } from 'lib/seo/seo';
import { NextSeo } from 'next-seo';

const setTitle = () => sections.introSection.lxPagePrivacyPolicyIntroSectionTitle();
const setDescription = () => sections.introSection.lxPagePrivacyPolicyIntroSectionText();

const SEO = {
  get TAB_TITLE() {
    return setTitle();
  },
  get NAME() {
    return setTitle();
  },
  get setTitle() {
    return setTitle();
  },
  get DESCRIPTION() {
    return setDescription();
  },
  URL: 'https://bumble.com/privacy-policy',
  IMAGE_URL: SHARE_IMAGE_URL,
  get IMAGE_ALT() {
    return setTitle();
  },
};

export type PageSEOPropsType = {
  browserTab?: string;
  seoTitle?: string;
  seoDescription?: string;
  seoUrl?: string;
  openTitle?: string;
  openDescription?: string;
  openImageUrl?: string;
  openImageAlt?: string;
  openSiteName?: string;
};

const PageSEO = (props: PageSEOPropsType) => {
  const lang = React.useContext(LocaleContext);
  const canonicalUrl = lang ? `${SEO.URL}/${lang}` : SEO.URL;
  const languageAlternates = getLanguageAlternates(
    'https://bumble.com',
    'privacy-policy',
    { lang: `/privacy-policy/${lang}` },
    undefined,
  ).filter((item) => item.href !== canonicalUrl);
  const imageUrl = 'https://bumble.com/bumble-brand-assets/bumble-share.jpg';
  const imageAlt = props.openImageAlt ? props.openImageAlt : SEO.IMAGE_ALT;
  const pageTitle = props.browserTab ? props.browserTab : SEO.TAB_TITLE;
  const pageDescriotion = props.seoDescription ? props.seoDescription : SEO.DESCRIPTION;
  const siteName = props.openSiteName ? props.openSiteName : SEO.NAME;

  return (
    <NextSeo
      title={pageTitle}
      description={pageDescriotion}
      canonical={canonicalUrl}
      languageAlternates={languageAlternates}
      openGraph={{
        url: canonicalUrl,
        title: props.openTitle ? props.openTitle : pageTitle,
        description: props.openDescription ? props.openDescription : pageDescriotion,
        images: [
          {
            url: imageUrl,
            alt: imageAlt,
            width: 1200,
            height: 630,
          },
        ],
        site_name: siteName,
      }}
      twitter={{
        handle: '@handle',
        site: '@site',
        cardType: 'summary_large_image',
      }}
    />
  );
};

export default PageSEO;
